import React from 'react'
import { CircularProgressbar } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import { Link } from 'react-router-dom'

function ProfileCompletion({ userProData }) {
  // Calculate progress percentage
  let progress = 0
  if (userProData.is_verified) progress += 25
  if (userProData.doc_submitted) progress += 25
  if (userProData.phoneNumberVerified && userProData.onRampMoneyKyc)
    progress += 25
  if (userProData.dfns_wallet_id !== '') progress += 25

  // If all flags are true, don't render the div
  if (progress === 100) return null

  return (
    <Link to='/myprofile'>
      <div className='flex justify-center gap-4 shadow-md rounded-lg p-3 border mx-12 mt-6 lg:mx-0 lg:mt-0'>
        <div className='w-16 h-16'>
          <CircularProgressbar
            value={progress}
            text={`${progress}%`}
            strokeWidth={9}
          />
        </div>
        <p className='mt-4 font-medium text-lg'>Please complete your profile</p>
      </div>
    </Link>
  )
}

export default ProfileCompletion
